import { render, staticRenderFns } from "./form-title.vue?vue&type=template&id=819dffe0&scoped=true&"
import script from "./form-title.vue?vue&type=script&lang=js&"
export * from "./form-title.vue?vue&type=script&lang=js&"
import style0 from "./form-title.vue?vue&type=style&index=0&id=819dffe0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "819dffe0",
  null
  
)

export default component.exports